<template>
  <v-dialog v-model="show" persistent max-width="400">
    <v-card>
      <v-card-title>Change password</v-card-title>
      <v-divider/>
        <v-form v-model="valid" immediate ref="form">
          <v-container class="mt-4">
            <v-row dense>
              <v-col>
                <v-text-field label="Old password" v-model="input.oldPassword" outlined dense
                          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showPassword ? 'text' : 'password'"
                          @click:append="showPassword = !showPassword"
                          :rules="[fieldRules.required]"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-text-field label="New password" v-model="input.newPassword" outlined dense counter
                          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showPassword ? 'text' : 'password'"
                          @click:append="showPassword = !showPassword"
                          :rules="[fieldRules.required,password]"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="show=false;$emit('input',false)">Cancel</v-btn>
        <v-btn color="primary" @click="set()">Set</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfigurationUserPassword',
  data() {
    return {
      valid: true,
      show: true,
      showPassword: false,
      input: {newPassword:'',oldPassword:''},
      password: v => {
        // eslint-disable-next-line no-useless-escape
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
        return pattern.test(v) || 'Min length 8 with at least one capital letter, a number and a special character';
      },
    }
  },
  methods: {
    async set() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      const response = await this.$auth.userPassword(this.$store.state.user.sub, this.input);
      if (response.status === 200) {
        this.user = response.data;
        this.show = false;
        this.$emit('input', false);
        this.$store.commit('setError', {type:'success',message:'Password changed'});
      }
      else
        this.$store.commit('setError', {type:'error',message:response.data.error_message});
    },
  }
}
</script>
